export const environment = {
  production: true
  , rest_service_url: "https://dirette.siamocalcio.it/dirette-admin-RestService/"
  , appName: "TifosInRete"
  , sso_id: "4a6dd8d91869b845ec91ab96a199dbda"
  , sicom_operatori_url: null
  , sicom_url: null
  , userController: 'user_tr/'
  , diretteController: 'dirette_tr/'
  , app_title: 'Tifosi In Rete | Dirette'
  , appFullName: 'Tifosi In Rete'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts